import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextareaWidget from './TextareaWidget';
import ChatBubbleIcon from 'material-ui-icons/ChatBubble';
import IconButton from 'material-ui/IconButton';
import { withStyles } from 'material-ui/styles';
import Button from 'material-ui/Button';
import Dialog, { withMobileDialog } from 'material-ui/Dialog';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import CloseIcon from 'material-ui-icons/Close';
import Slide from 'material-ui/transitions/Slide';

const styles = theme => ({
  appBar: {
    position: 'relative',
  },
  flex: {
    flex: 1,
  },
  chatIcon: {
    marginRight: -theme.spacing.unit * 2,
    marginLeft: -theme.spacing.unit,
  },
	nonFullScreenWrapper: {
    minWidth: '320px'
  }
});
function Transition(props) {
  return <Slide direction="up" {...props} />;
}
const DialogWrapper = props => {
  const {
    classes,
    open,
    onCancel,
    onClose,
    canSave,
    children,
    fullScreen,
  } = props;

  const saveLabel = value => {
      let s = '';
      s = value.props.formContext.formSchema.id === "wagri.inspection.wagri" ? 'Salvesta' : 'Tallenna';
      return s;
    };

  const cancelLabel = value => {
    let s = '';      
    s = value.props.formContext.formSchema.id === "wagri.inspection.wagri" ? 'Tühista' : 'Peruuta';
    return s;
  };
  
  const commentLabel = value => {
    let s = '';
    s = value.props.formContext.formSchema.id === "wagri.inspection.wagri" ? 'Kommenteerida' : 'Kommentti';
    return s;
  };

  return (
    <Dialog
      open={open}
      onRequestClose={onCancel}
      fullScreen={fullScreen}
      transition={Transition}
    >
      {fullScreen && (
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton color="contrast" onClick={onCancel}>
              <CloseIcon />
            </IconButton>
            <Typography type="title" color="inherit" className={classes.flex}>
              {commentLabel(children)}
            </Typography>
            {canSave && (
              <Button color="contrast" onClick={onClose}>
                {saveLabel(children)}
              </Button>
            )}
          </Toolbar>
        </AppBar>
      )}
      {children}
      {!fullScreen && (
        <div className={classes.nonFullScreenWrapper}>
          <Button color="accent" onClick={onCancel}>
            {cancelLabel(children)}
          </Button>
          {canSave && (
            <Button color="accent" onClick={onClose}>
              {saveLabel(children)}
            </Button>
          )}
        </div>
      )}
    </Dialog>
  );
};

DialogWrapper.propTypes = {
  classes: PropTypes.object,
  open: PropTypes.bool,
  canSave: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.element,
  fullScreen: PropTypes.bool,
};

const ResponsiveDialog = withMobileDialog()(withStyles(styles)(DialogWrapper));

class CommentWidget extends Component {
  state = {
    open: false,
    initialValue: '',
  };

  onDialogOpen = () => {
    const { value } = this.props;
    const initialValue = value === undefined ? '' : value;
    this.setState({ open: true, initialValue });
  };

  onDialogClose = (cancel = false) => {
    const { formContext } = this.props;
    if (formContext.formStatus === 'editable' && cancel) {
      this.props.onChange(this.state.initialValue);
    }
    this.setState({ open: false, initialValue: '' });
  };

  onCancel = () => {
    this.onDialogClose(true);
  };

  onSave = () => {
    this.onDialogClose(false);
  };

  render() {
    const { classes, formContext, ...textAreaProps } = this.props;
    const commentIconColor = textAreaProps.value ? 'accent' : 'default';
    return (
      <div>
        <IconButton
          onClick={this.onDialogOpen}
          className={classes.chatIcon}
          color={commentIconColor}
        >
          <ChatBubbleIcon />
        </IconButton>
        <ResponsiveDialog
          classes={classes}
          open={this.state.open}
          canSave={formContext.formStatus === 'editable'}
          onCancel={this.onCancel}
          onClose={this.onSave}
        >
          <TextareaWidget
            {...textAreaProps}
            formContext={formContext}
            autofocus={true}
          />
        </ResponsiveDialog>
      </div>
    );
  }
}

CommentWidget.propTypes = {
  classes: PropTypes.object,
  formContext: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
};

export default withStyles(styles)(CommentWidget);



// WEBPACK FOOTER //
// ./src/modules/common/components/form/widgets/CommentWidget.js